const estPsychologueOuPsychotherapeute = (authResult) => {
  return authResult.success && (authResult.estPsychologue || authResult.estPsychotherapeute)
}

let routes = [
  {
    path: '/repertoire/psychologue',
    component: () => import('../views/Repertoire/RepertoireRecherche.vue'),
    props: { service: 'PS' },
    children: [
      {
        meta: {
          guardedByToken: true,
          condition: estPsychologueOuPsychotherapeute
        },
        path: "",
        name: "RepertoireResultatsPsychologue",
        component: () => import('../components/Repertoire/Resultats.vue'),
      },
      {
        meta: {
          guardedByToken: true,
          condition: estPsychologueOuPsychotherapeute
        },
        path: ":id",
        name: "RepertoireDetailsPsychologue",
        component: () => import('../components/Repertoire/Details.vue'),
        props: true
      }
    ]
  },
  {
    path: '/repertoire/psychotherapeute',
    component: () => import('../views/Repertoire/RepertoireRecherche.vue'),
    props: { service: 'PT' },
    children: [
      {
        meta: {
          guardedByToken: true,
          condition: estPsychologueOuPsychotherapeute
        },
        path: "",
        name: "RepertoireResultatsPsychotherapeute",
        component: () => import('../components/Repertoire/Resultats.vue'),
      },
      {
        meta: {
          guardedByToken: true,
          condition: estPsychologueOuPsychotherapeute
        },
        path: ":id",
        name: "RepertoireDetailsPsychotherapeute",
        component: () => import('../components/Repertoire/Details.vue'),
        props: true
      }
    ]
  }
]

export default routes;